import {
	ROUTE_REPORTS_BILLING_BY_PRODUCT,
	ROUTE_REPORTS_BILLING_BY_PRODUCT_LIST
} from 'constants/RouterNames'

const reportBillingByProduct = () => import('components/pages/secured/reports/reportBillingByProduct/reportBillingByProduct')
const reportBillingByProductList = () => import('components/pages/secured/reports/reportBillingByProduct/reportBillingByProductColombo/reportBillingByProductList/reportBillingByProductListColombo')

const reportBillingByProductRoute = {
	path: '/report-billing-by-product',
	redirect: '/relatorio-faturamento-por-produto',
	component: reportBillingByProduct,
	name: ROUTE_REPORTS_BILLING_BY_PRODUCT.name,
	meta: { breadcrumb: { name: 'Faturamento por produto' }, requiresAuthorities: ROUTE_REPORTS_BILLING_BY_PRODUCT.routerAuth },
	children: [
		{ path: '/relatorio-faturamento-por-produto', component: reportBillingByProductList, name: ROUTE_REPORTS_BILLING_BY_PRODUCT_LIST.name, meta: { breadcrumb: { name: 'Listagem' }, requiresAuthorities: ROUTE_REPORTS_BILLING_BY_PRODUCT_LIST.routerAuth } }
	]
}

export default reportBillingByProductRoute
